import React from "react";
import PageOne from "./print/PrintPageOne";
import PageTwo from "./print/PrintPageTwo";
import PageThree from "./print/PrintPageThree";

export const AfsolPrintDocument = ({ form, mode = "electronic" }) => (
  <div style={{ background: "white" }}>
    <PageOne form={form} mode={mode} />
    <PageTwo form={form} mode={mode} />
    <PageThree form={form} />
  </div>
);

export default AfsolPrintDocument;
